import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import WeekDaysCalendar from '@supervisor/punch/WeekDaysCalendar';
import { withNamespaces } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-duotone-svg-icons";
import i18next from 'i18next';
import * as StatusEntries from '@scripts/StatusEntries';
import { toDisplayDecimal } from '@utils';
import Button from 'react-bootstrap-button-loader';
import imgApproved from "@images/approved.png";
import thumbsDown from "@images/thumbsDown2.png";
import thumbsUp from "@images/thumbsUp2.png";
import { punchApprove } from "@actionsSup/punchApproval";
import * as StatusApprove from "@scripts/PunchApproveStatus";
import * as ApprobationStructure from '@scripts/ApprobationStructure';
import { FloatingActionButton } from "@progress/kendo-react-buttons";
import { gearIcon, plusIcon, checkIcon } from "@progress/kendo-svg-icons";
import * as storage from '@storage'
import AlertAlgo from '@controls/AlertSnack';

const useStyles = makeStyles((theme) => ({
    divTitleNotApproved: {
        backgroundColor: '#5c7fb9',
        margin: '10px 6px',
        borderRadius: '10px',
        marginBottom: '10px',
        boxShadow: '1px 1px 4px 1px #b7b6b6',
        border: '1px solid #5070a5'
    },
    divTitleApproved: {
        backgroundColor: '#5c7fb9',
        margin: '10px 6px',
        borderRadius: '10px',
        marginBottom: '10px',
        boxShadow: '1px 1px 4px 1px #b7b6b6',
        border: '1px solid #5070a5'
    },
    title: {
        display: 'table',
        textAlign: 'left',
        padding: '10px',
        color: '#ffffff'
    },
    name: {
        textAlign: 'left',
        display: 'table',
        padding: '0 10px',
        borderRadius: '8px',
        color: '#000000',
        marginLeft: '10px'
    },
    totalHours: {
        textAlign: 'right',
        display: 'contents',
        float: 'right'
    },
    divHeader: {
        display: 'table',
        width: '57%',
        border: '0px solid red',
        float: 'left;'
    },
    divHours: {
        border: '0px solid blue',
        display: 'table',
        float: 'right',
        paddingRight: '10px',
        color: '#ffffff',
        textAlign: 'right',
        backgroundColor: '#5ccbff',
        borderRadius: '8px',
        marginRight: '8px',
        paddingLeft: '17px'
    },
    divCalendar: {
        display: 'table',
        width: '100%',
        paddingTop: '10px',
        fontSize: '12px'
    },
    buttonApprove: {
        width: '98%',
        maxWidth: '405px',
        padding: '0px',
        height: '35px',
        marginTop: '5px'
    },
    separator: {
        marginBottom: '15px'
    },
    imgApproved: {
        height: '40px'
    },
    thumbsUp: {
        float: 'left',
        height: '30px',
        marginTop: '6px',
        marginLeft: '8px'
    },
    thumbsDown: {
        float: 'left',
        height: '30px',
        marginTop: '10px',
        marginLeft: '8px'
    }
}));

function WeekCalendarEmployee(props) {
    const classes = useStyles();

    const [title, setTitle] = React.useState('');
    const [data, setData] = React.useState(null);
    const [category, setCategory] = React.useState(props.category);
    const [level, setLevel] = React.useState(props.level);
    const [intervalDate, setIntervalDate] = React.useState(null);
    const [cssCategory, setCssCategory] = React.useState({ divTitle: null, img: null });
    const useDoubleApprobation = storage.getUseDoubleApprobation();
    const approbationStructure = storage.getApprobationStructure();
    const isLevel2Approbator = storage.getIsLevel2Approbator();
    const alertRef = useRef(null);

    const handleTitle = () => {
        if (category == StatusEntries.Unapproved) {
            setTitle(i18next.t('punchApproval:title.unapproved_entries'));
            setCssCategory({ cssDivTitle: classes.divTitleNotApproved, cssImg: classes.thumbsDown, imgFile: thumbsDown });
            return;
        }

        setTitle(i18next.t('punchApproval:title.approved_entries'));
        setCssCategory({ cssDivTitle: classes.divTitleApproved, cssImg: classes.thumbsUp, imgFile: thumbsUp });
    }

    useEffect(() => {
        handleTitle();
    }, [category]);

    useEffect(() => {
        setIntervalDate(props.intervalDate);
    }, [props.intervalDate]);

    useEffect(() => {
        const dataNotApproved1 = props.data.filter(x => x.lst1?.length > 0);
        const dataNotApproved = props.data.filter(x => x.lst2?.length > 0);
        const dataApproved = props.data.filter(x => x.lstAp?.length > 0);

        if (category == StatusEntries.Unapproved) {
            if (dataNotApproved1.length > 0 || dataNotApproved.length > 0) {
                setData(props.data);
            }
        } else {
            if (dataNotApproved1.length == 0 && dataNotApproved.length == 0 && dataApproved.length > 0) {
                setData(props.data);
            }
        }
    }, [props.data, category]);

    const handleApprove = async (index, isApprove) => {
        let punchList;

        if (useDoubleApprobation) {
            punchList = data[index].lst1.concat(data[index].lst2);
        } else {
            punchList = data[index].lst2;
        }

        const punchIds = punchList.filter(x => x.isAp == false).map(x => ({ punchId: x.pchId, level: x.myL }));

        const response = await punchApprove(punchIds, isApprove);

        const result = handleResponsePunch(response);

        const isApproveStatus = result == StatusApprove.STATUS_APPROVED;

        setData(prevData => {
            const newData = [...prevData]; // copy array

            let punchListNew;

            if (useDoubleApprobation) {
                punchListNew = data[index].lst1.concat(data[index].lst2);
            } else {
                punchListNew = data[index].lst2;
            }

            punchListNew.forEach(item => {
                const objWarning = response.filter(x => JSON.parse(x).obj.punchCrypt == item.pchId && JSON.parse(x).warning == true);
                const objError = response.filter(x => JSON.parse(x).obj.punchCrypt == item.pchId && JSON.parse(x).error == true && JSON.parse(x).warning == false);

                const messageWarning = objWarning.length > 0 ? JSON.parse(objWarning).message : '';
                const messageError = objError.length > 0 ? JSON.parse(objError).message : '';

                let messageFinal = '';

                if (objWarning.length > 0) {
                    messageFinal = messageWarning;
                } else if (objError.length > 0) {
                    messageFinal = messageError;
                }

                item.message = messageFinal;

                let status = StatusApprove.STATUS_APPROVED;

                if (useDoubleApprobation && approbationStructure == ApprobationStructure.PROJECT && item.myL == 1) {
                    item.isAp1 = isApprove;
                } else {
                    item.isAp = isApprove;
                }

                if (messageWarning.length > 0) {
                    status = StatusApprove.STATUS_WARNING;
                } else if (messageError.length > 0) {
                    status = StatusApprove.STATUS_ERROR;
                    if (useDoubleApprobation && level == 1) {
                        item.isAp1 = !isApprove;
                    } else {
                        item.isAp = !isApprove;
                    }
                }

                item.status = status;
            });

            if (useDoubleApprobation) {
                // If not an error, so we add the punch in the approved list
                newData[index].lstAp = newData[index].lstAp.concat(punchListNew.filter(x => x.status !== StatusApprove.STATUS_ERROR));

                // Remove from lst1 and lst2 all punches that where approved
                newData[index].lst1 = newData[index].lst1.filter(x => x.status !== StatusApprove.STATUS_APPROVED && x.status !== StatusApprove.STATUS_WARNING);
                newData[index].lst2 = newData[index].lst2.filter(x => x.status !== StatusApprove.STATUS_APPROVED && x.status !== StatusApprove.STATUS_WARNING);

                // Copy isAp and isAp1 from lstAp to lst1 (matching by punchId)
                const apMap = new Map(
                    newData[index].lstAp.map(item => [
                        item.pchId,
                        { isAp: item.isAp, isAp1: item.isAp1 }
                    ])
                );
                newData[index].lst = newData[index].lst.map(item => ({
                    ...item,
                    isAp: apMap.get(item.pchId)?.isAp ?? item.isAp,  // preserve old if not found
                    isAp1: apMap.get(item.pchId)?.isAp1 ?? item.isAp1  // preserve old if not found
                }));

                newData[index] = {
                    ...newData[index],         // copy object
                    isAp1: isApproveStatus,      // update field
                    isAp: isApproveStatus,      // update field
                    //canAp: !isApproveStatus,
                    //canAp1: !isApproveStatus
                    canAp: false,
                    canAp1: false
                };
            } else {
                newData[index] = {
                    ...newData[index],         // copy object
                    isAp: isApproveStatus,      // update field
                    canAp: !isApproveStatus
                };
            }
            return newData;
        });

        if (result == StatusApprove.STATUS_APPROVED) {
            alertRef.current.showMessageSuccess(i18next.t('punchApproval:message.weekApprove'));
        } else if (result == StatusApprove.STATUS_PARTIAL_APPROVED) {
            alertRef.current.showMessageSuccess(i18next.t('punchApproval:message.partialApprove'));
        }
    }

    const handleResponsePunch = (response) => {
        let status = StatusApprove.STATUS_APPROVED;

        let qtySuccess = 0;
        let qtyFailed = 0;

        response.forEach(item => {
            const obj = JSON.parse(item);

            if (obj.error == true) {
                qtyFailed++;
            } else if (obj.success) {
                qtySuccess++;
            }
        });

        if (qtyFailed > 0 && qtySuccess > 0) {
            status = StatusApprove.STATUS_PARTIAL_APPROVED;
        } else if (qtyFailed > 0) {
            status = StatusApprove.STATUS_NOT_APPROVED;
        }

        return status;
    }

    const items = [
        {
            svgIcon: checkIcon,
            text: i18next.t('punchApproval:button.approveAll'),
            className: classes.approveAllButton,
            disabled: false

        },
        {
            svgIcon: plusIcon,
            text: i18next.t('punchApproval:button.add'),
            disabled: false
        }
    ];

    return (
        <>
            {data && data.map((obj, index) => {
                const canApprove = (obj.canAp || obj.canAp1) && category == StatusEntries.Unapproved;

                const isApproved = useDoubleApprobation ? obj.lstAp.length > 0 && obj.lst1.length == 0 && obj.lst2.length == 0
                    : obj.isAp;

                const totalHours = obj.th;

                return (<React.Fragment key={index}>
                    <div className={classes.divHeader}>
                        <span className={classes.name}>{obj.n}</span>
                    </div>
                    <div className={classes.divHours} onClick={() => props.detailDialogEvent.open(obj.epct, obj.ec, category, level)}>
                        <span className={classes.totalHours}>{`${toDisplayDecimal(totalHours, 2)} ${i18next.t('punchApproval:label.hours')}`}</span>
                        <FontAwesomeIcon icon={faChevronRight} style={{ paddingTop: "5px", display: 'flex', float: 'right', paddingLeft: '10px' }} />
                    </div>
                    <div className={classes.divCalendar} onClick={() => props.detailDialogEvent.open(obj.epct, obj.ec, category, level)}>
                        <WeekDaysCalendar
                            intervalDate={intervalDate}
                            data={{ dataLv1: obj.lst1, dataLv2: obj.lst2, dataApproved: obj.lstAp }}
                            category={props.category} />
                    </div>
                    <div>
                        {canApprove &&
                            <>
                                <Button
                                    onClick={() => handleApprove(index, true)}
                                    variant="success"
                                    className={classes.buttonApprove}
                                >
                                    {i18next.t('buttons:approve')}
                                </Button>
                                {/*<FloatingActionButton className={`addButtonFab floatingActionButton`} svgIcon={plusIcon} items={items} onItemClick={() => handleApprove(index, true)} />*/}
                            </>
                        }
                        {category != StatusEntries.Approved && isApproved && !canApprove &&
                            <img className={classes.imgApproved} src={imgApproved} />
                        }
                    </div>
                    <div className={classes.separator}></div>
                    <AlertAlgo ref={alertRef} />
                </React.Fragment>)
            }
            )}
        </>
    );
}

export default withNamespaces(['punchApproval', 'buttons'], { wait: true })(WeekCalendarEmployee);